<template>
  <b-row>
    <b-col
      v-for="(item, index) in tableData"
      :key="index"
      sm="12"
      md="6"
      lg="4"
      xl="3"
    >
      <b-card
        tag="article"
        no-body
        style="border: 1px solid rgba(0, 0, 0, 0.125)"
      >
        <b-card-body>
          <b-card-text>
            <span class="text_title mb-2">{{
              item.scmName ? item.scmName : '--'
            }}</span>
            <div class="d-flex  mt-2">
              <div class="mb-2">
                <b-badge
                  :variant="
                    item.isCooperation === 'Y' ? 'success' : 'secondary'
                  "
                >
                  {{ item.isCooperationName }}
                </b-badge>
              </div>
              <div class="ml-1">
                <b-badge
                  :variant="
                    item.scmMode === 'C'
                      ? 'success'
                      : item.scmMode === 'A'
                      ? ''
                      : 'info'
                  "
                >
                  {{ item.scmModeName ? item.scmModeName : 'Not set' }}
                </b-badge>
              </div>
            </div>
            <span class="text_description mb-2">{{ item.scmMemo }}</span>
            <div>
              <span class="text_left"
                ><b-icon icon="shop-window" class="mr-2"></b-icon
              ></span>
              <span class="table-text">{{
                item.scmCategoryName || 'Category Not Set'
              }}</span>
            </div>
            <div>
              <span class="text_left"
                ><b-icon icon="people" class="mr-2"></b-icon>
              </span>
              <span class="table-text"
                ><b>{{ item.visits ? item.visits : '--' }}</b> visits</span
              >
            </div>
            <div>
              <span class="text_left"
                ><b-icon icon="star" class="mr-2"></b-icon
              ></span>
              <span class="table-text"
                >{{ item.topScore ? item.topScore : '--' }} / <b>{{ item.scmScore ? item.scmScore : '--' }}</b> score</span
              >
            </div>
          </b-card-text>
          <div class="d-flex justify-content-between">
            <div>
              <span class="text_left">{{ item.createDateEn }}</span>
            </div>
            <div>
              <a class="table-text" @click="detail(item)" role="button"
                ><i class="el-icon-thumb"></i>
                <span class="ml-2">View more</span></a
              >
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col v-if="!isShow" style="text-align: center">
      <b-card class="mt-5">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  computed: {},
  components: {},
  // 数据
  data() {
    return {}
  },
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    isShow: {
      default: true,
    },
  },
  // 侦听器
  watch: {},
  // 生命周期钩子
  mounted() {},
  // 事件处理方法
  methods: {
    detail(val) {
      let params = {
        scmCode: val.scmCode,
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmInfoDetail',
        params: params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.text_title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 40px;
  line-height: 20px;
  font-size: 18px;
  color: #6c757d;
  font-weight: 700;
}

.text_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
  font-size: 13px;
  color: #98a6ad !important;
}

.text_more {
  font-size: 13px;
  color: #98a6ad !important;
  font-weight: 700 !important;
}

.text_left {
  font-size: 13px;
  color: #98a6ad !important;
}
.table-text {
  color: #6c757d;
  font-size: 14px;
}
</style>
